export default __webpack_public_path__ + "static/avatar-e75e8a36d724ee72e7f038fef8f2710f.jpg";